import { Paper, Typography, Chip, Grid, Stack, Divider, Box, TextField, IconButton, Tooltip, Select, MenuItem, Button, InputAdornment, Table, TableHead, TableBody, TableRow, TableCell, TableContainer, Alert, ToggleButton, ToggleButtonGroup, Link } from "@mui/material";
import { Add as AddIcon, Remove as RemoveIcon, PersonAdd as PersonAddIcon, Info as InfoIcon, PointOfSale as PosIcon, RemoveRedEye, AttachMoneyOutlined, CreditCardOutlined, AccountBalanceOutlined, CallSplitOutlined, DeleteOutline, ArrowBackOutlined, RequestQuoteOutlined, CheckCircleRounded, RadioButtonUncheckedRounded, DonutLargeRounded } from "@mui/icons-material";
import LinearProgress from '@mui/material/LinearProgress';
import { ShoppingCartCheckout as CheckoutIcon, } from "@mui/icons-material";
import React, { useEffect } from "react";
import { StyledCellHeader } from "../../../../components/StyledCellHeader";
import { formatNumberWithCommas, getMySQLDateTime } from "../../../../utils/generalFunctions";
import AlertMessageDialog from "../../../../components/Dialogs/alertMessageDialog";
import {impresionrecibopago} from "../../prestamos/pagos/imprimirpagos";
import { parse } from "date-fns";

const PAYMENT_METHODS = [
  { value: 'efectivo', label: 'Efectivo', Icon: AttachMoneyOutlined, color: 'success' },
  { value: 'tarjeta', label: 'Tarjeta', Icon: CreditCardOutlined, color: 'primary' },
  { value: 'transferencia', label: 'Transferencia', Icon: AccountBalanceOutlined, color: 'info' },
];

const currencyRD = (v) => {
  // Handle string values with commas or other formatting
  if (typeof v === 'string') {
    // Remove commas and convert to number
    const numValue = parseFloat(v.replace(/,/g, ''));
    if (isNaN(numValue)) return 'RD$0.00';
    return new Intl.NumberFormat("es-DO", { style: "currency", currency: "DOP" }).format(numValue);
  }
  // Handle number values
  if (typeof v === 'number' && !isNaN(v)) {
    return new Intl.NumberFormat("es-DO", { style: "currency", currency: "DOP" }).format(v);
  }
  // Fallback for invalid values
  return 'RD$0.00';
};

const INVOICE_TYPES = [
    { id: "cf01", name: "Crédito fiscal (01)" },
    { id: "nv02", name: "Nota de venta (02)" },
  ];
  
export default function ReceiptPagoPanel({
    prestamoDetalle,
    cuotas,
    setSelectedCuotas,
    selectedCuotas,
    checkedCuotas,
    shiftOpen,
    reiniciar,
    recuperacionesValor,
    ultPago,
    cargosAsignados = [],
    onCargosCobrados,
  }) {

    const [pago,setPago] = React.useState("");
    const [capitalPago,setCapitalPago] = React.useState(0);
    const [recuperaciones,setRecuperaciones] = React.useState(recuperacionesValor);
    const [descuento,setDescuento] = React.useState(0);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState('');
    const [success, setSuccess] = React.useState('');
    const [mora,setMora] = React.useState(0);

    // Inline payment method state (replaces the MetodoDePagoDialog flow).
    const [paymentMethod, setPaymentMethod] = React.useState('efectivo');
    const [reference, setReference] = React.useState('');
    const [splitMode, setSplitMode] = React.useState(false);
    const [splitPayments, setSplitPayments] = React.useState([]);
    const [splitDraft, setSplitDraft] = React.useState({ method: 'efectivo', amount: '', reference: '' });

    // Distribuye el monto ingresado FIFO sobre los cargos asignados pendientes.
    // Devuelve { aplicados: [{id_cargo_asignado, categoria, monto, saldo_despues}], totalCargos, sobrante }.
    const computeCargosFIFO = React.useCallback((montoDisponible) => {
      let restante = parseFloat(montoDisponible) || 0;
      const aplicados = [];
      for (const c of (cargosAsignados || [])) {
        if (restante <= 0) break;
        const saldo = parseFloat(c.saldo);
        if (saldo <= 0) continue;
        const abono = Math.min(saldo, restante);
        aplicados.push({
          id_cargo_asignado: c.id,
          categoria: c.categoria_nombre,
          monto: parseFloat(abono.toFixed(2)),
          saldo_antes: saldo,
          saldo_despues: parseFloat((saldo - abono).toFixed(2)),
        });
        restante -= abono;
      }
      const totalCargos = aplicados.reduce((s, a) => s + a.monto, 0);
      return { aplicados, totalCargos: parseFloat(totalCargos.toFixed(2)), sobrante: parseFloat(restante.toFixed(2)) };
    }, [cargosAsignados]);

    const cargosCobroPreview = React.useMemo(() => {
      const total = parseFloat((pago || '0').toString().replace(/,/g, '')) || 0;
      const neto = Math.max(0, total - (parseFloat(recuperaciones) || 0));
      return computeCargosFIFO(neto);
    }, [pago, recuperaciones, computeCargosFIFO]);


    function handlepago(texto) {     
      setPago(texto);
      setMora(0);
      if(prestamoDetalle.metodo == 'plazo_indefinido' && JSON.parse(prestamoDetalle.interes_producto)['interesDiario']){
        if (texto.length < 15){
          
          if (texto){
            setPago(texto);
            var pago = texto
            var datos = []
            var brutoNeto = parseFloat(pago.replace(/,/g,""))-recuperaciones
            var cargosFifo = computeCargosFIFO(brutoNeto)
            var valorapagar = brutoNeto - cargosFifo.totalCargos
            var valorpagado = "0.00"
            var valorapagarmora  = 0


            if(valorapagar > 0){
            cuotas.map((amortiza)=>{

            
              let valorcuota = parseFloat(amortiza['valor'])
              let valormora =  parseFloat(amortiza['mora'])
              
              if(valorapagar <= (valorcuota+valormora)) {
                  if (valorapagar <= valormora) {                    
                      valorapagarmora = parseFloat(valorapagar).toFixed(2)
                      valorapagar = 0.0
                      valorpagado = parseFloat('0.00').toFixed(2)                   
                  } else {
                    
                      valorapagarmora = parseFloat(valormora).toFixed(2)
                      valorapagar = parseFloat(valorapagar - valormora).toFixed(2)
                    
                      if (valorapagar <= valorcuota) {
                        valorpagado = parseFloat(valorapagar).toFixed(2) 
                        valorapagar = 0
                            
                      } else {
                        valorpagado = valorcuota
                        valorapagar = parseFloat(valorapagar - valorcuota).toFixed(2)
                  
                      }
                    
                  }
                } 
                else {
            
                  if (valorapagar <= valormora) {
                    valorapagarmora = parseFloat(valormora).toFixed(2)
                    valorapagar = parseFloat('0.00').toFixed(2) 
                  } else {
                    valorapagarmora = parseFloat(valormora).toFixed(2)
                    valorapagar = parseFloat(valorapagar - valormora).toFixed(2)
                    
                    if (valorapagar <= valorcuota) {
                        valorapagar = parseFloat('0.00').toFixed(2)
                        valorpagado = parseFloat(valorcuota).toFixed(2) 
                    } else {
                      valorpagado = parseFloat(valorcuota).toFixed(2)
                      valorapagar = parseFloat(valorapagar - valorcuota).toFixed(2)
                    }}         
              }
    
    
              if(valorpagado != 0 || valorapagarmora != 0){
                
                datos.push({nocuota:Number(amortiza['nocuota']),interes:valorcuota,capital:ultPago?ultPago['capital']:prestamoDetalle.monto_solicitado,
                  capitalPagado:0,cuotapagado:valorpagado,morapagado:valorapagarmora,cuota:amortiza['cuotaoriginal'],
                  pendiente:(valorcuota-valorpagado).toFixed(2),descuento:amortiza['descuento'],
                  pagadodescuento:amortiza['pagadodescuento'],status:amortiza['status'],fecha:amortiza['Fecha']})
               
              }

            })
            setMora(datos.reduce((acc,curr)=>acc+parseFloat(curr.morapagado),0));
            setSelectedCuotas(datos);
            }    
            setCapitalPago(valorapagar-datos.reduce((acc,curr)=>acc+parseFloat(curr.pendiente),0)-recuperaciones>=0?valorapagar-datos.reduce((acc,curr)=>acc+parseFloat(curr.pendiente),0)-recuperaciones:0);
            
          
          }
          else{
            setSelectedCuotas([])
          }
        }
      }
      else{
        if (texto.length < 15){
          if ((texto)){
             setPago(texto);
             var pago = texto
             var datos = []
             var brutoNeto2 = parseFloat(pago.replace(/,/g,""))-recuperaciones
             var cargosFifo2 = computeCargosFIFO(brutoNeto2)
             var valorapagar = brutoNeto2 - cargosFifo2.totalCargos
             var valorpagado = "0.00"
             var valorapagarmora  = 0
             var valorapagarorigina = valorapagar
             cuotas.map((amortiza)=>{
             
               let valorcuota = parseFloat(amortiza['valor'].replace(/,/g,""))
               let valormora =  parseFloat(amortiza['mora'])
               
               if(valorapagar <= (valorcuota+valormora)) {
                   if (valorapagar <= valormora) {
                      valorapagarmora = parseFloat(valorapagar).toFixed(2)
                      valorapagar = 0.0
                      valorpagado = parseFloat('0.00').toFixed(2)                   
                   } else {
                     
                      valorapagarmora = parseFloat(valormora).toFixed(2)
                      valorapagar = parseFloat(valorapagar - valormora).toFixed(2)
                     
                      if (valorapagar <= valorcuota) {
                         valorpagado = parseFloat(valorapagar).toFixed(2) 
                         valorapagar = 0
                             
                       } else {
                        valorpagado = valorcuota
                        valorapagar = parseFloat(valorapagar - valorcuota).toFixed(2)
                   
                      }
                     
                   }
                } 
                else {
             
                 if (valorapagar <= valormora) {
                   valorapagarmora = parseFloat(valormora).toFixed(2)
                   valorapagar = parseFloat('0.00').toFixed(2) 
                 } else {
                   valorapagarmora = parseFloat(valormora).toFixed(2)
                   valorapagar = parseFloat(valorapagar - valormora).toFixed(2)
                   
                   if (valorapagar <= valorcuota) {
                      valorapagar = parseFloat('0.00').toFixed(2)
                      valorpagado = parseFloat(valorcuota).toFixed(2) 
                   } else {
                     valorpagado = parseFloat(valorcuota).toFixed(2)
                     valorapagar = parseFloat(valorapagar - valorcuota).toFixed(2)
                   }}         
               }
    
    
               if(valorpagado != 0 || valorapagarmora != 0){
                
                  datos.push({
                    'nocuota'  : Number(amortiza['nocuota']),
                    'fecha'    : amortiza['Fecha'],
                    'valor'    : valorcuota,
                    'mora'     : valormora,
                    'cuotapagado'   : valorpagado,
                    'morapagado'  : valorapagarmora,
                    'pendiente'  : (valorcuota - valorpagado).toFixed(2),
                    'capitalPagado' : 0,
                    'interesPagado' : 0,
                    'moraPagado' : 0,
                    'interes' : amortiza['sinteres']?amortiza['sinteres']:amortiza['interes'],
                    'capital' : amortiza['scapital']?amortiza['scapital']:amortiza['capital'],
                    'cuota' : amortiza['interes'],
                    'descuento' : amortiza['descuento'],
                    'status' : amortiza['sinteres']?'':'noexiste',
                  })
                  
               }
             })
             setMora(datos.reduce((acc,curr)=>acc+parseFloat(curr.morapagado),0));
             setCapitalPago(valorapagar-datos.reduce((acc,curr)=>acc+parseFloat(curr.pendiente),0)-recuperaciones>=0?valorapagar-datos.reduce((acc,curr)=>acc+parseFloat(curr.pendiente),0)-recuperaciones:0);
             setSelectedCuotas(datos);
      
    
           
          }
        }
    
      }
    }

    useEffect(() => {
      if(checkedCuotas.length > 0){
        var valorCuotas = checkedCuotas.reduce((acc,curr)=>acc+parseFloat(curr.valor),0);
        var valorMora = checkedCuotas.reduce((acc,curr)=>acc+parseFloat(curr.mora),0);
        
        handlepago(formatNumberWithCommas(valorCuotas+valorMora));
      }
    }, [checkedCuotas]);

    // Arma la lista de métodos de pago a partir del state inline (single o split).
    const buildPayments = () => {
      const total = parseFloat((pago || '0').toString().replace(/,/g, '')) || 0;
      if (splitMode) {
        return splitPayments.map((p) => ({ method: p.method, amount: p.amount, reference: p.reference || '' }));
      }
      return [{ method: paymentMethod, amount: total, reference: reference.trim() }];
    };

    const validateBeforeSubmit = () => {
      const total = parseFloat((pago || '0').toString().replace(/,/g, '')) || 0;
      if (total <= 0) return 'Ingrese el monto a pagar';
      if (selectedCuotas.length === 0 && prestamoDetalle.metodo != 'plazo_indefinido') {
        return 'No hay cuotas seleccionadas para pagar';
      }

      if (splitMode) {
        if (splitPayments.length === 0) return 'Agregue al menos un método de pago';
        const sum = splitPayments.reduce((acc, p) => acc + parseFloat(p.amount || 0), 0);
        if (Math.abs(sum - total) > 0.01) return 'El total de los pagos combinados debe igualar el monto';
      } else {
        if (paymentMethod !== 'efectivo' && !reference.trim()) {
          return 'Ingrese la referencia del pago';
        }
      }
      return null;
    };

    const handlePaymentConfirm = async () => {
      const validationError = validateBeforeSubmit();
      if (validationError) {
        setError(validationError);
        return;
      }

      if(prestamoDetalle.metodo == 'plazo_indefinido'){
        
        var cuotasData = selectedCuotas;
        if(capitalPago > 0){
          var nocuota = ultPago?ultPago.numero_cuota:1;
          var now = new Date();
          var fechaUltPago = `${now.getDate()}-${now.getMonth()+1}-${now.getFullYear()}`

          cuotasData.push({nocuota:nocuota,interes:0,
            capital:ultPago?ultPago['capital']-capitalPago:prestamoDetalle.monto_solicitado-capitalPago,capitalPagado:capitalPago,cuota:0
            ,cuotapagado:0,cuota:0,morapagado:0,pendiente:0,descuento:0,pagadodescuento:0,status:'noexiste',
            fecha:fechaUltPago})
        }
      }

      setLoading(true);
      setError('');

      const paymentRequest = {
        id_prestamo: prestamoDetalle.prestamo_original_id,
        interesDiario: prestamoDetalle.metodo != 'plazo_indefinido' ? false : JSON.parse(prestamoDetalle.interes_producto)['interesDiario'],
        id_usuario: localStorage.getItem('id'),
        id_sucursal: localStorage.getItem('id_sucursal'),
        idcompany: localStorage.getItem('idcompany'),
        id_cliente: prestamoDetalle.id_cliente,
        monto_pagado: parseFloat(pago.replace(/,/g, ""))-recuperaciones,
        recuperaciones: recuperaciones,
        metodo_pago: buildPayments(),
        fecha_pago: getMySQLDateTime(),
        observaciones: splitMode ? '' : reference.trim(),
        pagos_cuotas: selectedCuotas,
        cargos_pagados: cargosCobroPreview.aplicados.map((c) => ({
          id_cargo_asignado: c.id_cargo_asignado,
          monto: c.monto,
        })),
        cliente: {
          nombre: prestamoDetalle.cliente_nombre,
          identificacion: prestamoDetalle.cliente_identificacion,
        },
      };

      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/pagos-prestamo${prestamoDetalle.metodo == 'plazo_indefinido' ? '/plazo_indefinido' : ''}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
        },
        body: JSON.stringify(paymentRequest)
      });

      const result = await response.json();

      if (result.success) {
        setSuccess('Pago procesado exitosamente');
        if (onCargosCobrados) onCargosCobrados();
        setPago('');
        impresionrecibopago(localStorage.getItem('nombre_compania'),"Recibo de pago",selectedCuotas,
          prestamoDetalle.cliente_identificacion,prestamoDetalle.cliente_nombre,
          prestamoDetalle.loan_id,prestamoDetalle.prestamo_solicitud_id,prestamoDetalle.capitalPendiente,mora,capitalPago,
          prestamoDetalle.interesPendiente,prestamoDetalle.moraPendiente,
          cargosCobroPreview.totalCargos, prestamoDetalle.metodo);
        setSelectedCuotas([]);
        setSplitPayments([]);
        setReference('');
        setSplitMode(false);
        setPaymentMethod('efectivo');
        setTimeout(() => {
          setSuccess('');
          reiniciar();
        }, 2000);
      } else {
        setError(result.message || 'Error al procesar el pago');
      }
      setLoading(false);
    };

    const totalPagoNum = parseFloat((pago || '0').toString().replace(/,/g, '')) || 0;
    const splitSum = splitPayments.reduce((acc, p) => acc + parseFloat(p.amount || 0), 0);
    const splitRemaining = Math.max(totalPagoNum - splitSum, 0);

    const handleAddSplitPayment = () => {
      const amt = parseFloat((splitDraft.amount || '').toString().replace(/,/g, '')) || 0;
      if (amt <= 0) { setError('Monto inválido'); return; }
      if (amt > splitRemaining + 0.01) { setError('El monto excede el restante'); return; }
      if (splitDraft.method !== 'efectivo' && !splitDraft.reference.trim()) {
        setError('Ingrese la referencia'); return;
      }
      setSplitPayments([...splitPayments, { ...splitDraft, amount: amt, id: Date.now() }]);
      setSplitDraft({ method: 'efectivo', amount: '', reference: '' });
      setError('');
    };

    const handleRemoveSplitPayment = (id) => {
      setSplitPayments(splitPayments.filter(p => p.id !== id));
    };
  
    return (
      <>
        <Paper
        elevation={1}
        sx={{
          backgroundColor:"white",
          borderRadius: 2,
          p: 2,
          top: 16,
          width: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1}>
          <Typography variant="h6" fontWeight={700}>
            Pago de prestamo
          </Typography>
  
          <Chip
            size="small"
            icon={<PosIcon />}
            color={shiftOpen ? "success" : "default"}
            label={`Caja: ${shiftOpen ? "Disponible" : "Cerrada"}`}
            variant={shiftOpen ? "filled" : "outlined"}
          />
        </Stack>
  
        <Grid container spacing={1} mb={1}>
          <Grid item size={12} textAlign={"left"}  mx={2} display={"flex"} >
              <Typography fontWeight={600}>Prestamo:</Typography>
              <Typography sx={{marginLeft:1}}>{prestamoDetalle.loan_id}</Typography>             
          </Grid>
          <Grid item size={12} textAlign={"left"}  mx={2} display={"flex"} >
              <Typography fontWeight={600}>Cliente:</Typography>
              <Typography sx={{marginLeft:1}}>{prestamoDetalle.cliente_nombre}</Typography>             
              <RemoveRedEye sx={{marginLeft:1,width:20,height:20,marginTop:0.1,color:"primary.main"}} size="small"/>
          </Grid>
          <Grid item size={12} textAlign={"left"}  mx={2} display={"flex"} >
              <Typography fontWeight={600}>Fecha:</Typography>
              <Typography sx={{marginLeft:1}}>{new Date().toLocaleDateString()}</Typography>             
          </Grid>

        </Grid>
  
        <Typography fontWeight={600} textAlign={"left"} sx={{marginTop:2,mx:2}}>Pago a realizar</Typography>
        <Stack direction="row" spacing={1} alignItems="center" mb={1} mx={2}>
          
          <TextField
            size="small"
            fullWidth
            sx={{borderColor:"primary.main",borderWidth:2}}
            value={formatNumberWithCommas(pago)}
            onChange={(e) => handlepago(e.target.value)}
            slotProps={{
              input: {
                startAdornment:(
                  <InputAdornment position="start">{"RD"}$</InputAdornment>
                ) 
              },
            }}
/>
          
        </Stack>
        {prestamoDetalle.metodo == 'plazo_indefinido' && <Stack direction="row" justifyContent="space-between" mb={0.5} mx={2}>
          <Typography color="text.secondary">Capital</Typography>
          <Typography color="text.secondary">{currencyRD(capitalPago)}</Typography>
        </Stack>}

        {cargosAsignados && cargosAsignados.length > 0 && (
          <Box
            sx={{
              mx: 2,
              mt: 1.5,
              borderRadius: 2,
              overflow: 'hidden',
              border: '1px solid',
              borderColor: 'divider',
              bgcolor: 'background.paper',
              boxShadow: '0 1px 2px rgba(15, 23, 42, 0.04)',
            }}
          >
            {/* Header */}
            <Box
              sx={{
                px: 1.75,
                py: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                bgcolor: (theme) =>
                  theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.04)' : '#F8FAFC',
                borderBottom: '1px solid',
                borderColor: 'divider',
              }}
            >
              <Stack direction="row" alignItems="center" spacing={1}>
                <RequestQuoteOutlined sx={{ fontSize: 18, color: 'primary.main' }} />
                <Typography variant="body2" fontWeight={700} color="text.primary" letterSpacing={0.1} align="left">
                  Cargos asignados
                </Typography>
              </Stack>
              <Chip
                size="small"
                variant="outlined"
                label="Se cobran primero"
                sx={{ height: 20, fontSize: '0.68rem', fontWeight: 600, letterSpacing: 0.3 }}
              />
            </Box>

            {/* Lista de cargos */}
            <Box sx={{ px: 1.75, py: 1 }}>
              <Stack divider={<Divider flexItem sx={{ borderStyle: 'dashed' }} />} spacing={0.75}>
                {cargosAsignados.map((c) => {
                  const aplicado = cargosCobroPreview.aplicados.find((a) => a.id_cargo_asignado === c.id);
                  const abono = aplicado ? aplicado.monto : 0;
                  const saldo = parseFloat(c.saldo) || 0;
                  const saldoDespues = aplicado ? aplicado.saldo_despues : saldo;
                  const cobertura = saldo > 0 ? Math.min(100, (abono / saldo) * 100) : 0;
                  const completo = abono > 0 && saldoDespues <= 0.009;
                  const parcial = abono > 0 && !completo;

                  const StatusIcon = completo
                    ? CheckCircleRounded
                    : parcial
                    ? DonutLargeRounded
                    : RadioButtonUncheckedRounded;
                  const statusColor = completo
                    ? 'success.main'
                    : parcial
                    ? 'info.main'
                    : 'text.disabled';

                  return (
                    <Box key={c.id} sx={{ py: 0.5 }}>
                      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
                        <Stack direction="row" alignItems="center" spacing={1} sx={{ minWidth: 0, flex: 1 }}>
                          <StatusIcon sx={{ fontSize: 16, color: statusColor }} />
                          <Box sx={{ minWidth: 0 }}>
                            <Typography
                              variant="body2"
                              fontWeight={600}
                              align="left"
                              noWrap
                              color={abono > 0 ? 'text.primary' : 'text.secondary'}
                            >
                              {c.categoria_nombre}
                            </Typography>
                            <Typography variant="caption" color="text.secondary" sx={{ lineHeight: 1.2 }}>
                              Saldo {currencyRD(saldo)}
                              {abono > 0 && (
                                <>
                                  {' → '}
                                  <Typography component="span" variant="caption" color={completo ? 'success.main' : 'info.main'} fontWeight={600}>
                                    {currencyRD(saldoDespues)}
                                  </Typography>
                                </>
                              )}
                            </Typography>
                          </Box>
                        </Stack>
                        <Typography
                          variant="body2"
                          fontWeight={700}
                          sx={{ fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' }}
                          color={abono > 0 ? (completo ? 'success.main' : 'info.main') : 'text.disabled'}
                        >
                          {abono > 0 ? currencyRD(abono) : '—'}
                        </Typography>
                      </Stack>
                      {abono > 0 && (
                        <LinearProgress
                          variant="determinate"
                          value={cobertura}
                          color={completo ? 'success' : 'info'}
                          sx={{
                            mt: 0.75,
                            height: 4,
                            borderRadius: 4,
                            bgcolor: (theme) =>
                              theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.08)' : '#EEF2F6',
                          }}
                        />
                      )}
                    </Box>
                  );
                })}
              </Stack>
            </Box>

            {/* Footer total */}
            <Box
              sx={{
                px: 1.75,
                py: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                borderTop: '1px solid',
                borderColor: 'divider',
                bgcolor: (theme) =>
                  theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.02)' : '#FAFBFC',
              }}
            >
              <Typography variant="caption" fontWeight={700} color="text.secondary" letterSpacing={0.4} sx={{ textTransform: 'uppercase' }}>
                Total aplicado a cargos
              </Typography>
              <Typography
                variant="body2"
                fontWeight={800}
                sx={{ fontVariantNumeric: 'tabular-nums' }}
                color={cargosCobroPreview.totalCargos > 0 ? 'success.main' : 'text.disabled'}
              >
                {currencyRD(cargosCobroPreview.totalCargos)}
              </Typography>
            </Box>
          </Box>
        )}

        <Divider sx={{ my: 1 }} />
  
        <Box sx={{ flex: 1, overflowY: "auto", pr: 1 }}>
          {pago.length === 0 ? (
            <Stack height="100%" alignItems="center" justifyContent="center" spacing={1} color="text.secondary">
            <InfoIcon />
            <Typography variant="body2">Ingrese el monto a pagar.</Typography>
          </Stack>
        ) : (
            <TableContainer component={Paper} variant="outlined" sx={{borderRadius:2,maxHeight:200}}>
            <Table>
              <TableHead>
                <TableRow>
                  <StyledCellHeader>No. Cuota</StyledCellHeader>
                  <StyledCellHeader>Pagado</StyledCellHeader>
                  <StyledCellHeader>Mora</StyledCellHeader>
                  <StyledCellHeader>Balance</StyledCellHeader>
                </TableRow>
              </TableHead>
              <TableBody>
                {selectedCuotas.map((cuota) => (
                  <TableRow key={cuota.id}>
                    <StyledCellHeader>{cuota.nocuota}</StyledCellHeader>
                    <StyledCellHeader>{cuota.cuotapagado} </StyledCellHeader>
                    <StyledCellHeader>{cuota.morapagado}</StyledCellHeader>
                    <StyledCellHeader>{cuota.pendiente}</StyledCellHeader>
                  </TableRow>
                ))}
            </TableBody>
            </Table>
            </TableContainer>
          )}

        </Box>
  
        <Box sx={{ pt: 1 }}>
        <Stack direction="row" justifyContent="space-between" mb={0.5}>
            <Typography color={recuperaciones > 0 ? "error.main" : "text.secondary"}>Recuperaciones</Typography>
            <Typography color={recuperaciones > 0 ? "error.main" : "text.secondary"}>{currencyRD(recuperaciones)}</Typography>
          </Stack>

          <Stack direction="row" justifyContent="space-between" mb={0.5}>
            <Typography color="text.secondary">Descuento</Typography>
            <Typography color="text.secondary">{currencyRD(descuento)}</Typography>
          </Stack>


          <Stack direction="row" justifyContent="space-between" mb={0.5}>
            <Typography color="text.secondary">Total Mora</Typography>
            <Typography color="text.secondary">{currencyRD(mora)}</Typography>
          </Stack>

          <Stack direction="row" justifyContent="space-between" mb={0.5}>
            <Typography color="text.secondary">Subtotal</Typography>
            <Typography color="text.secondary">{currencyRD(pago)}</Typography>
          </Stack>

  
          {error && (
            <AlertMessageDialog
              open={error}
              handleClose={() => setError('')}
              title="Error al procesar el pago"
              message={error}
              severity="error"
            />
          )}

          {success && (
            <AlertMessageDialog
              open={success}
              onClose={() => setSuccess('')}
              title="Pago procesado exitosamente"
              message={success}
              severity="success"
            />
          )}

          {/* Inline payment method selection (replaces MetodoDePagoDialog flow) */}
          {pago && pago.length > 0 && (
            <Box sx={{ mt: 1.5, mb: 1 }}>
              {!splitMode && (
                <>
                  <Typography variant="caption" color="text.secondary" sx={{ display: 'block', fontSize: '0.68rem', fontWeight: 600, letterSpacing: '0.06em', textTransform: 'uppercase', mb: 0.75 }}>
                    Método de pago
                  </Typography>
                  <ToggleButtonGroup
                    value={paymentMethod}
                    exclusive
                    onChange={(_, v) => { if (v) { setPaymentMethod(v); setError(''); } }}
                    fullWidth
                    size="small"
                    sx={{ mb: paymentMethod !== 'efectivo' ? 1.5 : 0 }}
                  >
                    {PAYMENT_METHODS.map(({ value, label, Icon }) => (
                      <ToggleButton key={value} value={value} sx={{ textTransform: 'none', fontWeight: 600, py: 0.75 }}>
                        <Icon sx={{ fontSize: 18, mr: 0.75 }} />
                        {label}
                      </ToggleButton>
                    ))}
                  </ToggleButtonGroup>
                  {paymentMethod !== 'efectivo' && (
                    <TextField
                      fullWidth
                      size="small"
                      placeholder={paymentMethod === 'tarjeta' ? 'Número de autorización' : 'Referencia de transferencia'}
                      value={reference}
                      onChange={(e) => setReference(e.target.value)}
                      onKeyPress={(e) => { if (e.key === 'Enter' && !loading) handlePaymentConfirm(); }}
                    />
                  )}
                  <Link
                    component="button"
                    underline="hover"
                    onClick={() => { setSplitMode(true); setError(''); }}
                    sx={{ mt: 1, fontSize: '0.78rem', fontWeight: 600, color: 'primary.main', display: 'inline-flex', alignItems: 'center', gap: 0.5 }}
                  >
                    <CallSplitOutlined sx={{ fontSize: 14 }} /> Dividir en varios métodos
                  </Link>
                </>
              )}

              {splitMode && (
                <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1.5, p: 1.5, bgcolor: 'background.default' }}>
                  <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
                    <Typography variant="caption" fontWeight={700} sx={{ textTransform: 'uppercase', letterSpacing: '0.06em', fontSize: '0.68rem' }}>
                      Pago dividido · Restante {currencyRD(splitRemaining)}
                    </Typography>
                    <Link component="button" underline="hover" onClick={() => { setSplitMode(false); setSplitPayments([]); setError(''); }} sx={{ fontSize: '0.72rem', fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: 0.25 }}>
                      <ArrowBackOutlined sx={{ fontSize: 12 }} /> Pago único
                    </Link>
                  </Stack>

                  {splitPayments.map((p) => {
                    const meta = PAYMENT_METHODS.find(m => m.value === p.method);
                    return (
                      <Stack key={p.id} direction="row" alignItems="center" justifyContent="space-between" sx={{ py: 0.5, borderBottom: '1px dashed', borderColor: 'divider' }}>
                        <Stack direction="row" alignItems="center" spacing={0.75}>
                          {meta?.Icon && <meta.Icon sx={{ fontSize: 16, color: `${meta.color}.main` }} />}
                          <Typography variant="body2" fontWeight={600}>{meta?.label}</Typography>
                          {p.reference && <Typography variant="caption" color="text.secondary">· {p.reference}</Typography>}
                        </Stack>
                        <Stack direction="row" alignItems="center" spacing={0.5}>
                          <Typography variant="body2" fontWeight={700}>{currencyRD(p.amount)}</Typography>
                          <IconButton size="small" onClick={() => handleRemoveSplitPayment(p.id)}>
                            <DeleteOutline sx={{ fontSize: 16 }} />
                          </IconButton>
                        </Stack>
                      </Stack>
                    );
                  })}

                  {splitRemaining > 0 && (
                    <Stack direction="row" spacing={0.75} mt={1} alignItems="flex-start">
                      <TextField
                        size="small"
                        select
                        value={splitDraft.method}
                        onChange={(e) => setSplitDraft({ ...splitDraft, method: e.target.value })}
                        sx={{ minWidth: 110 }}
                      >
                        {PAYMENT_METHODS.map(m => <MenuItem key={m.value} value={m.value}>{m.label}</MenuItem>)}
                      </TextField>
                      <TextField
                        size="small"
                        placeholder="Monto"
                        value={splitDraft.amount}
                        onChange={(e) => setSplitDraft({ ...splitDraft, amount: e.target.value.replace(/[^0-9.]/g, '') })}
                        slotProps={{ input: { startAdornment: <InputAdornment position="start">RD$</InputAdornment> } }}
                      />
                      {splitDraft.method !== 'efectivo' && (
                        <TextField
                          size="small"
                          placeholder="Referencia"
                          value={splitDraft.reference}
                          onChange={(e) => setSplitDraft({ ...splitDraft, reference: e.target.value })}
                        />
                      )}
                      <IconButton color="primary" onClick={handleAddSplitPayment}>
                        <AddIcon />
                      </IconButton>
                    </Stack>
                  )}
                </Box>
              )}
            </Box>
          )}

          {error && (
            <AlertMessageDialog
              open={error}
              handleClose={() => setError('')}
              title="Error al procesar el pago"
              message={error}
              severity="error"
            />
          )}

          {success && (
            <AlertMessageDialog
              open={success}
              onClose={() => setSuccess('')}
              title="Pago procesado exitosamente"
              message={success}
              severity="success"
            />
          )}

          {prestamoDetalle.metodo == 'plazo_indefinido' ? (
            <Button
              variant="contained"
              fullWidth
              size="large"
              color="primarybutton"
              startIcon={<CheckoutIcon />}
              sx={{ borderRadius: 1 , fontWeight:"bold"}}
              disabled={(!shiftOpen || !pago || loading)}
              onClick={handlePaymentConfirm}
            >
              {loading ? 'Procesando…' : `Pagar · ${formatNumberWithCommas(pago)}`}
            </Button>
          ) : (
            <Button
              variant="contained"
              fullWidth
              size="large"
              color="primarybutton"
              startIcon={<CheckoutIcon />}
              sx={{ borderRadius: 1 , fontWeight:"bold"}}
              disabled={(cuotas.length === 0 || !shiftOpen || selectedCuotas.length === 0 || !pago || loading)}
              onClick={handlePaymentConfirm}
            >
              {loading ? 'Procesando…' : `Pagar · ${currencyRD(pago)}`}
            </Button>
          )}
          <Stack direction="row" justifyContent="flex-end" mt={0.5}>
            <Button size="small" onClick={() => window.location.reload()}>Cancelar</Button>
          </Stack>
        </Box>
      </Paper>
    </>
  );
}
  